export const useDocumentViewModeStore = (documentId: string) => {
  if (!documentId) {
    throw new Error("DocumentId is not defined");
  }

  return useDocumentViewMode(documentId)();
};
